import React, { useRef, useImperativeHandle } from 'react';
import styled from '../../styled';
const FileInput = styled.input `
  display: none !important;
`;
const ImageUpload = ({ onChange, onError, render, accept = 'image/*', allowMultiple = false, innerRef, className, }) => {
    const fileInputRef = useRef(null);
    // @ts-ignore
    useImperativeHandle(innerRef, () => fileInputRef.current);
    const onFileInputClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const onFileChange = (event) => {
        try {
            const { files } = event.target;
            const filesData = [];
            if (files && files.length > 0) {
                const fileReader = new FileReader();
                fileReader.addEventListener('load', function onFileLoad() {
                    if (fileReader.result) {
                        filesData.push(fileReader.result);
                    }
                    if (filesData.length === files.length) {
                        onChange(filesData, files);
                    }
                }, false);
                for (let i = 0; i < files.length; i += 1) {
                    fileReader.readAsDataURL(files[i]);
                }
            }
        }
        catch (e) {
            onError(e);
        }
    };
    return (React.createElement("div", { className: className },
        render(onFileInputClick),
        React.createElement(FileInput, { type: "file", ref: fileInputRef, onChange: onFileChange, accept: accept, multiple: allowMultiple })));
};
export default React.forwardRef((props, ref) => React.createElement(ImageUpload, Object.assign({ innerRef: ref }, props)));
//# sourceMappingURL=ImageUpload.js.map